export default __webpack_public_path__ + "static/media/wheel-4.a95d53a6.png";